import React, { useMemo } from 'react';
import ContentWrapper from '../ContentWrapper';
import FormCard from '../FormCard';
import { useBackgroundInfo } from 'hooks/newUniprofile/useBackgroundInfo';
import Healthcare from './components/Healthcare';
import Education from './components/Education';
import DemographicDetails from './components/DemographicDetails';
import Treatment from './components/Treatment';
import Recognition from './components/Recognition';
import { Spin } from 'antd';

interface BackgroundStepProps {
    isReview?: boolean;
}

export default function BackgroundStep({ isReview = false }: BackgroundStepProps) {
    const [background, loading, refetch, updateBackgroundInfo] = useBackgroundInfo();
    console.log('background', background);

    const hasContentForBiographic = useMemo(() => {
        return Object.values(background.biographic).some((value) => Boolean(value));
    }, [background]);

    const hasContentForRecognition = useMemo(() => {
        return (
            Boolean(background.awardRecognitionList?.length) ||
            Boolean(background.associationRecognitionList?.length) ||
            Boolean(background.publicationRecognitionList?.length)
        );
    }, [background]);

    return (
        <Spin spinning={loading}>
            <ContentWrapper title="Background (optional)" description="Share your experience and care approach to help patients learn more about you." showInfo={!isReview}>
                <FormCard type={isReview ? 'review' : 'add'} title="Healthcare experience" isOptional hasContent={Boolean(background.providerExperienceList?.length)}>
                    {(isEditing) => <Healthcare isEditing={isEditing} initValue={background.providerExperienceList} updateFn={updateBackgroundInfo} />}
                </FormCard>
                <FormCard type={isReview ? 'review' : 'add'} title="Education" isOptional hasContent={Boolean(background.providerEducationList?.length)}>
                    {(isEditing) => <Education isEditing={isEditing} initValue={background.providerEducationList} updateFn={updateBackgroundInfo} />}
                </FormCard>
                <FormCard type={isReview ? 'review' : 'add'} title="Treatment methodology" isOptional hasContent={Boolean(background.treatmentPhilosophy)}>
                    {(isEditing) => <Treatment isEditing={isEditing} initValue={background.treatmentPhilosophy} conversationId={background.philosophyConversationId} updateFn={updateBackgroundInfo} />}
                </FormCard>
                <FormCard type={isReview ? 'review' : 'add'} title="Demographic details" isOptional hasContent={hasContentForBiographic}>
                    {(isEditing) => <DemographicDetails isEditing={isEditing} initValue={background.biographic} hasContent={hasContentForBiographic} updateFn={updateBackgroundInfo} />}
                </FormCard>
                <FormCard type={isReview ? 'review' : 'add'} title="Recognition" isOptional hasContent={hasContentForRecognition}>
                    {(isEditing) => <Recognition isEditing={isEditing} awardRecognitionList={background.awardRecognitionList} associationRecognitionList={background.associationRecognitionList} publicationRecognitionList={background.publicationRecognitionList} updateFn={updateBackgroundInfo} />}
                </FormCard>
            </ContentWrapper>
        </Spin>
    );
}
